<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-park">
<h1>The Park</h1>
<p style="text-indent: 00em;">I walk through the park with the big gnarly trees</p>
<p style="text-indent: 00em;">And their beautiful long limbs sway in the breeze</p>
<p style="text-indent: 00em;">They’ve been there a long time, I’m told</p>
<p style="text-indent: 00em;">Some are well over 100 years old</p>
<p style="text-indent: 00em;">When the strong summer winds come on by</p>
<p style="text-indent: 00em;">Lots of branches are ripped off and die</p>
<p style="text-indent: 00em;">But the birds in the vicinity love these trees</p>
<p style="text-indent: 00em;">As they gently swing and sway in the breeze</p>
<p style="text-indent: 00em;">They build lots of nests, the boughs are just right</p>
<p style="text-indent: 00em;">Then they come back here and roost at night</p>
<p style="text-indent: 00em;">There are large monkey puzzle trees, they give the park a charm</p>
<p style="text-indent: 00em;">But look out when they shed, the pods may do you harm</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch015.vue?bca185fe